import { Translation } from 'src/types';

const translations: Translation = {
  translation: {
    Buttons: {
      back: 'Nazaj',
      changePassword: 'Spremeni geslo',
      copiedVaultId: 'Kopirano!',
      copyVaultID: 'Kopiraj Vault ID',
      create: 'Ustvari',
      next: 'Naslednji',
      notSure: 'Nisem prepričan',
      signUp: 'Prijavite se',
      submit: 'Pošlji',
      updatePassword: 'Posodobi geslo',
    },
    Errors: {
      createReportFailed: 'Ustvarjanje poročila ni uspelo.',
    },
    ReportStatus: {
      CLOSED: 'Zaprto',
      INVESTIGATING: 'Preiskovanje',
      NEW: 'Poslano',
      READ: 'Prebrano',
    },
    general: {
      navbar: {
        caseSettings: 'Nastavitve primera',
        changePassword: 'Spremeni geslo',
        logOut: 'Odjava',
        notifications: 'Obvestila',
        notificationsDrawer: {
          appFileScanFailed: 'Datoteka ni prestala varnostne preverjanje',
          appReportMatch: 'Vaš zapis GoTogether je bil usklajen',
          appReportReassigned: 'Dodeljen je bil nov vodja primera.',
          case: 'Primer',
          caseAssigned: 'Primer dodeljen vam',
          caseImporterJobCompleted: {
            PartialSuccess: 'Uvoz vašega primera je bil zaključen z napakami.',
            failure: 'Uvoz vašega primera ni uspel',
            success: 'Uvoz vaše zadeve je bil uspešno zaključen',
          },
          caseLinked: 'Primer povezan',
          caseTeamInvite: 'Dodano v primer',
          caseUnlinked: 'Primer odstranjen',
          dataSanitisation: 'Podrobnosti poročila so posodobljene',
          emptyDescription: 'Preverite kasneje za nove obvestila.',
          emptyTitle: 'Vse ste posodobljeni.',
          importId: 'Uvozni ID:',
          learnMore: 'Izvedite več',
          markAllAsRead: 'Označi vse kot prebrano',
          newMessage: 'Novo sporočilo',
          newReport: 'Prejeto novo poročilo',
          permissionRemoved: 'Odstranjeno iz primera',
          postSSubmissionFile: 'Dodane datoteke z dokazi',
          report: 'Poročilo',
          reportAssigned: 'Poročilo dodeljeno vam',
          reportStatusChange: 'Spremenjen status poročila',
          reporterAnonymised: 'Vaši podatki so bili anonimizirani',
          reporterReportSubmitted: {
            subtitle: 'Priporočamo, da shranite kopijo svojega poročila',
            title: 'Predloženo poročilo',
          },
          mitigationPlanReminder: 'Zahtevana je odobritev načrta za ublažitev',
          staleCase: 'Nedokončan primer',
        },
        privacyStatement: 'Izjava o zasebnosti',
        reporter: {
          myReports: 'Moja poročila',
        },
        settings: 'Nastavitve',
        technicalSupport: 'Tehnična podpora',
        title: 'Račun',
      },
      time: {
        day: 'Dan',
        days: 'Dnevi',
        hour: 'Ura',
        hours: 'Ure',
        minute: 'Minuta',
        minutes: 'Zapisnik',
        second: 'Drugi',
        seconds: 'Sekunde',
      },
    },
    public: {
      ChatContainer: {
        anonymousLabel: 'Anonimno',
        autoTranslate: 'Avtomatsko prevajanje je privzeto izklopljeno.',
        backToMessages: 'Nazaj na sporočila',
        caseSettings: 'Nastavitve primera.',
        changeInProfile:
          'Če želite to nastavitev spremeniti, lahko to storite v svojem profilu.',
        deletedByMessage: 'Izbrisal {{author}}',
        deletedMessageLabel: 'To sporočilo je bilo izbrisano',
        description:
          'Ko je vklopljeno samodejno prevajanje, bodo vsa sporočila poročil samodejno prevedena z uporabo AI glede na privzeti jezik, izbran v vašem brskalniku.',
        descriptionSecondHalf:
          'Izvirna različica vseh sporočil je vedno ohranjena in jo je mogoče najti v klepetu.',
        messagePlaceholder: 'Začni tipkati...',
        messageSettings: 'Nastavitve sporočil.',
        originalMessages: 'Izvirnik',
        showMoreBanner: 'Več o samodejnih prevodih',
        titlev2: 'Preberite vsa sporočila v vašem prednostnem jeziku.',
        translatedMessageLabel: 'Prevedeno Sporočilo',
        translatedMessages: 'Prevedeno',
        understood: 'Razumljeno',
      },
      Country: {
        description: 'V kateri državi delate?',
        header: 'V kateri državi delate?',
        noOptions: 'Nobene države ni bilo mogoče najti',
        other: 'Drugo',
        placeholder: 'Poiščite državo...',
      },
      CreatePublicReport: {
        createReport: 'Ustvari novo poročilo',
        helpPage: 'Pojdite na našo stran za pomoč',
        loginToOpr: 'Prijavite se za sledenje poročil',
        or: 'ali',
        passwordPlaceholder: 'Vnesite geslo',
        phoneNumberLoginFailed:
          'Prijava ni uspela, telefonska številka / pin je napačen.',
        phoneNumberPlaceholder: 'Vnesite svojo telefonsko številko',
        phoneNumberTooltip:
          'Vnesite telefonsko številko, ki ste jo uporabili za stik z VaultTalk.',
        pinPlaceholder: 'Vnesite PIN',
        reportIntroductionParagraph1:
          'Ko poročate o incidentu, boste morali odgovoriti na nekaj vprašanj, ki vam bodo pomagala dokumentirati vašo izkušnjo.',
        reportIntroductionParagraph2:
          'Preden oddate, imate možnost ostati anonimni za zaščito vaše zasebnosti.',
        reportIntroductionParagraph3:
          'Po oddaji se lahko kadarkoli prijavite, da vidite napredek svojega poročila in se pogovorite s skrbnikom primera.',
        reportIssue: 'Prijavite težavo',
        usernameLoginFailed:
          'Prijava ni uspela, uporabniško ime / geslo je napačno',
        validationError: {
          publicReport: {
            relationshipToCompanyRequired: 'Zahtevano je razmerje do podjetja.',
            reportedCategoryRequired: 'Zahtevana je prijavljena kategorija.',
          },
        },
        vaultId: 'Vaultov ID',
        vaultIdPlaceholder: 'Vnesite svoj e-poštni naslov ali ID Vault.',
        vaultIdTooltip:
          'Za anonimna poročila je ID osebe Vault alfanumeričen. Če poročilo ni bilo anonimno, je ID osebe Vault vaš e-poštni naslov.',
        vaultTalk: 'VaultTalk',
        yourPassword: 'Vaše geslo',
        yourPhoneNumber: 'Vaša telefonska številka',
        yourPin: 'Vaša 6-mestna PIN koda',
        yourVaultId: 'Vaša Vault ID',
      },
      CustomHeader: {
        companyLogo: 'Logotip podjetja',
        openReporting: 'Odprite poročanje',
        userSettings: 'Uporabniške nastavitve',
      },
      Date: {
        approximateDescription: 'Se spomnite okvirnega datuma dogodka?',
        approximatePlaceholder: 'Primer: pred 6 meseci / lani / lani novembra',
        cancel: 'prekliči',
        clear: 'očisti',
        description: 'Se spomnite datuma dogodka?',
        header: 'Kateri dan se je to zgodilo?',
        ok: 'v redu',
        placeholder: 'Primer: 21. junija 2020',
      },
      Description: {
        whatHappened: 'Kaj se je zgodilo?',
        whatHappenedPlaceholder: 'Uporabite svoje besede ...',
        whatHappenedText: 'S svojimi besedami opišite, kaj se je zgodilo',
      },
      Details: {
        disclaimer:
          'Podrobnosti bodo razkrite z vašim poročilom. Če želite ostati anonimni, poskrbite, da ne vsebujejo identifikacijskih informacij.',
        emailPlaceholder: 'E-pošta (izbirno)',
        fullNamePlaceholder: 'Polno ime (izbirno)',
        header: 'Vaše podrobnosti',
        nonAnonSubtitle:
          'Prosimo, da navedete bodisi svoje ime ali e-poštni naslov. Če želite prejemati obvestila o tem poročilu, spodaj vnesite ustrezni e-poštni naslov.',
        nonOptionalEmailPlaceholder: 'E-pošta',
        nonOptionalFullNamePlaceholder: 'Polno Ime',
        subtitle:
          'Če želite prejemati obvestila o tem poročilu, spodaj dodajte ustrezni e-poštni naslov.',
      },
      Emotion: {
        description: 'Kako ste se počutili? Kakšen je bil vpliv?',
        header: 'Kakšen je bil vpliv?',
        placeholder: 'Začnite tipkati ...',
      },
      Evidence: {
        addedHeading: 'Dodano',
        deletedMessage: 'je bil izbrisan',
        deletedStatus: 'Izbrisano',
        failedToOpenFileMessage: 'Odprtje datoteke ni uspelo. Poskusite znova.',
        fileStatuses: {
          infectedUpload: 'Označeno s strani varnostnega pregleda',
          passedUpload: 'Prešel varnostni pregled',
          pendingUpload: 'Varnostni pregled poteka',
          readyForDownload: 'Pripravljeno za prenos',
        },
        mobileErrorMessage:
          'Označene datoteke: sporočite svojemu skrbniku primera',
        nameHeading: 'Ime',
        statusHeading: 'Stanje',
        tableTitle: 'Dokaz',
        webErrorMessage:
          'Označene datoteke: Če je bila vaša datoteka/e označena, prosim pošljite sporočilo upravitelju primera.',
      },
      FileUpload: {
        addFiles: 'Dodaj datoteke',
        addMoreFiles: 'Dodaj več datotek',
        confirm: 'Potrdi',
        description:
          'Dodajanje datotek kot dokaz lahko pomaga podpreti učinkovitost rešitve, ki jo vodi vaš upravitelj primera. Prosimo, upoštevajte vsebino datoteke (vključno z metapodatki datoteke), če želite ostati anonimni, in spoštujte pravice drugih posameznikov ter veljavne zakone.',
        dragDrop: 'Spustite datoteke tukaj ali',
        errorMessage:
          'Datoteka(e) so spodletela zaradi napake v omrežju. Kliknite spodaj, da pošljete sporočilo vašemu upravitelju primera za pomoč.',
        fileLimit: 'Omejitev velikosti posamezne datoteke: 100MB',
        fileUploadLimitText: 'Naložite lahko samo 10 datotek.',
        header: 'Dodaj dokaze',
        helpArticle: 'članki za pomoč',
        highlighted: 'brskaj po datotekah',
        information: 'Podprte vrste datotek',
        moreInformation:
          'Za več informacij si oglejte to <a>članki za pomoč</a>',
        postSubmissionErrorMessage:
          "Vaših datotek nismo mogli naložiti zaradi sistemske napake. Prosimo, ponovno izberite 'potrdi'.",
        tooltipAudio: 'Zvok:',
        tooltipAudioOptions: '.ogg, .wav, .wma',
        tooltipDocuments: 'Dokumenti:',
        tooltipDocumentsOptions:
          '.ps, .docx, .doc, .pptx, .ppt, .xlsx, .xls, .dcm, .pdf',
        tooltipImage: 'Slike:',
        tooltipImageOptions:
          '.png, .apng, .jpg, .jpeg, .pjpeg, .svg, .gif, .tiff, .tif, .bmp, .psd, .avif',
        tooltipText: 'Besedilo:',
        tooltipTextOptions: '.txt, .csv, .html, .xml',
        tooltipVideo: 'Video:',
        tooltipVideoOptions: '.mp4, .mov, .mp1s, .asf',
        uploadErrors: {
          invalidFileSize: 'Datoteka je prevelika',
          invalidFileType: 'Nepodprta vrsta datoteke: {{extension}}',
          systemError: 'Sistemska napaka',
          tooManyFiles: 'Maksimalno število datotek je {{maxFiles}}',
        },
        uploadFiles: 'Naloži datoteke',
      },
      Loading: {
        loading:
          'Prosimo, počakajte, medtem ko vaše poročilo posredujemo upravitelju primera...',
        postSubmissionLoading:
          'Prosimo, počakajte, medtem ko oddajamo vašo datoteko(-e)...',
      },
      Location: {
        description: 'Kje se je to zgodilo?',
        header: 'Kje se je to zgodilo?',
        placeholder: 'Primer: v pisarni',
      },
      MessageListBox: {
        messageCaseManager: 'Pošljite sporočilo upravitelju primera',
        report: 'Poročilo {{displayReportId}} {{submissionType}}',
      },
      MessageSettings: {
        enableTranslationLabelDisabled: 'Prevajanje onemogočeno',
        enableTranslationLabelEnabled: 'Prevajanje omogočeno',
        enableTranslationsDescription:
          'Omogočite samodejne prevode in berite vsa poročila v svojem izbranem jeziku. Prevod jezika temelji na jeziku, ki ste ga izbrali na svoji napravi.',
        enableTranslationsHeader:
          'Omogoči samodejno prevajanje za sporočila poročil',
        enableTranslationsSubDescriptionv2:
          'Med vsakim klepetom lahko preklapljate med prevedenim in izvirnim jezikom.',
        updateTranslationFailed: 'Posodobitev prevoda ni uspela',
        updateTranslationSuccess:
          'Nastavitev prevoda je bila uspešno posodobljena',
      },
      Password: {
        changePasswordHeader: 'Spremenite geslo',
        createNewPassword: 'Prosimo, ustvarite novo geslo',
        createPasswordHeader: 'Vaše geslo',
        currentPasswordPlaceholder: 'Vnesite trenutno geslo',
        description:
          'Veljavno geslo mora biti dolgo vsaj 9 znakov in mora vsebovati eno veliko črko in eno številko',
        enterCurrentPassword: 'Prosimo, vnesite svoje trenutno geslo',
        forgottenPasswordInstructions:
          'Vnesite svojo alfanumerično Vault ID (ne vašega e-poštnega naslova) in e-poštni naslov za ponastavitev gesla.',
        newDescription:
          'Ustvarite močno geslo, da bo vaš račun varen. Začnite tipkati, da boste spodaj videli smernice.',
        passwordPlaceholder: 'Ustvarite geslo',
        passwordResetRequestedDescription:
          'Če vaša osebna številka Vault obstaja v našem sistemu, boste prejeli e-pošto z navodili za ponastavitev gesla.',
        passwordResetRequestedHeader:
          'Zahtevana povezava za ponastavitev gesla',
        reenterPlaceholder: 'Ponovno vnesite geslo',
        subtitle:
          'Ustvarite geslo za oddajo tega poročila in dostop v prihodnosti',
        yourVaultId: 'Vaša identifikacija Vault',
        yourVaultIdPlaceholder:
          'Vnesite svojo Vault ID (na primer {{exampleId}})',
      },
      Perpetrators: {
        description:
          'Ali prijavljate določeno osebo ali več oseb? Ali jih lahko poimenujete ali opišete?',
        header: 'Udeleženi ljudje',
        placeholder:
          'Začnite tipkati in uporabite vejico, da dodate več imen ali opisov',
      },
      PoweredByVault: 'Poganja ga {{company}}',
      PrivacyStatement: 'Izjava o zasebnosti izdelka',
      PublicMessageList: {
        myMessages: 'Moja sporočila',
      },
      PublicMoreEvidence: {
        additionalEvidenceHeader: 'Dokazi dodani k obstoječemu poročilu',
        backToReportId: 'Nazaj na poročilo ID: {{reportId}}',
        description:
          'Dodajanje datotek kot dokaz lahko pomaga podpreti učinkovitost rešitve vašega upravitelja primerov. Prosimo, upoštevajte vsebino datoteke (vključno z metapodatki datoteke), če želite ostati anonimni, in spoštujte pravice drugih posameznikov in veljavne zakone. Za več informacij si oglejte to <a>članki za pomoč</a>',
        header: 'Dodajte dodatne dokaze v poročilo',
        vaultTalkOpenCaseHeader: 'Dodaj dokaze v svoje poročilo',
      },
      PublicReport: {
        anonymous: 'Anonimno',
        backToReports: 'Nazaj na sporočila',
        skipped: 'Preskočeno',
      },
      PublicReportCard: {
        addEvidence: 'Dodaj dodatne dokaze',
        messageCaseManager: 'Pošljite sporočilo upravitelju primera',
        reportId: 'ID poročila:',
        submitted: 'Poslano',
        vaultTalkClosedCaseCTA: 'Ogled Dokazov',
        vaultTalkOpenCaseCTA: 'Dodaj dokaz',
        viewAdditionalEvidence: 'Oglejte si dodatne dokaze',
        viewReport: 'Ogled poročila',
      },
      PublicReportsList: {
        reportingSystem: 'Sistem poročanja',
      },
      Question: {
        placeholder: 'Začnite tipkati...',
        question: 'Navedite podrobnosti',
        questionText:
          'Prosimo, delite z nami svoje skrbi, posodobitve ali povpraševanja.',
      },
      Relationship: {
        header: 'Vaš odnos do organizacije',
        tellUsAbout: 'Povejte nam, prosim, o svojem odnosu z organizacijo.',
      },
      ResponsiveNavMenu: {
        messages: 'Moja sporočila',
        reports: 'Moja poročila',
      },
      Site: {
        description: 'Na kateri lokaciji delate?',
        header: 'Na kateri lokaciji delate?',
        noOptions: 'Lokacije niso najdene',
        other: 'Drugo',
        placeholder: 'Iskanje lokacije...',
      },
      SpamPuzzle: {
        dialog: 'Če želite nadaljevati, rešite to uganko',
      },
      SubmissionTypes: {
        reportIssue: 'Izberite kategorijo',
        whatType: 'Izberite kategorijo, ki najbolje opisuje vaše poročilo',
      },
      SubmitSuccess: {
        category: '<bold>Kategorija:</bold> {{category}}',
        country: '<bold>Država:</bold> {{country}}',
        dateSubmitted: '<bold>Datum oddaje:</bold> {{date}}',
        recordYourVaultID: 'Zapomni si te podatke za prijavo',
        successInformation: 'Več informacij',
        successMessage:
          'Vaše poročilo je bilo oddano in je pripravljeno za pregled. Vse priložene datoteke, ki potrebujejo pozornost, bodo označene ob prijavi. Prijavite se spodaj, da si ogledate posodobitve poročila in pošljete sporočilo vašemu upravitelju primera.',
        successSanitationMessage:
          'Shranite kopijo za svoje evidence in varno shranite svojo Vault-ID - potrebovali jo boste za dostop do posodobitev in za pošiljanje sporočil vašemu vodji primera.',
        successSanitationTagline:
          'Vaše poročilo je bilo poslano in varno shranjeno.',
        successThankYou: 'Hvala za vaše poročilo!',
        viewReport: 'Ogled poročila',
      },
      Time: {
        approximateDescription:
          'Se spomnite približno časa, ko se je dogodek zgodil?',
        approximatePlaceholder: 'Primer: zjutraj, popoldne',
        description: 'Se spomnite ure, ko se je dogodek zgodil?',
        header: 'Ob kateri uri se je zgodilo?',
        invalidTime: 'Oblika časa mora biti HH:MM',
      },
      UserSettingsDialog: {
        changePassword: 'Spremenite geslo',
        closeDialog: 'Zapri pogovorno okno',
        logout: 'Odjava',
        messageSettings: 'Nastavitve sporočil',
        userSettings: 'Uporabniške nastavitve',
      },
      Witnesses: {
        description:
          'Ste povedali komu drugemu ali je kdo videl, kaj se je zgodilo?',
        header: 'Imate priče?',
        placeholder: 'Začnite tipkati ...',
      },
    },
    reporting: {
      MessageSlideIn: {
        confirmButton: 'Pošlji sporočilo',
        title: 'Sporočilo Upravitelj primerov',
        translationHeader: 'Več o avtomatskih prevodih',
      },
      ReportCard: {
        addEvidence: 'Dodaj dokaze',
        submissionModeVia: 'prek {{submissionMode}}',
        viewEvidence: 'Oglejte si dokaze',
      },
      ReportList: {
        yourReports: 'Vaša poročila',
      },
      ReportingActivate: {
        buttonText: 'Nadaljuj',
        description:
          'Če vas je vaša organizacija registrirala za račun, vam bomo poslali e-pošto z navodili za dokončanje nastavitve.',
        emailInput: 'E-pošta',
        header: 'Vnesite svoj službeni e-poštni naslov',
        successAccount:
          'Če vas je vaša organizacija registrirala za račun, vam bomo poslali e-pošto z navodili za dokončanje nastavitve.',
        successEmail:
          'Če tega takoj ne vidite, prosimo, počakajte nekaj minut in osvežite svojo e-poštni predal.',
        successHeading: 'Hvala',
      },
      ReportingAddEvidence: {
        descriptionHeader: 'Dodaj dokaze k tvojemu poročilu',
        descriptionText:
          'Dodajanje datotek kot dokaza lahko pomaga pri učinkovitosti reševanja vašega upravitelja primera. Prosimo, upoštevajte vsebino datoteke (vključno z metapodatki datoteke), če želite ostati anonimni, in spoštujte pravice drugih posameznikov ter veljavne zakone. Za več informacij si oglejte ta <a>članka za pomoč</a>.',
        emptyMessage: 'Ni dodatnih dokazov naloženih',
      },
      ReportingChangePassword: {
        back: 'Nazaj',
        description:
          'Ustvarite močno geslo za zagotovitev varnosti vašega računa. Začnite tipkati, da vidite smernice spodaj.',
        errorToast: 'Ne morem ustvariti gesla, neveljaven žeton.',
        header: 'Spremeni geslo',
        incorrectCurrentPassword:
          'Trenutno geslo je napačno. Prosimo, preverite ga in poskusite znova.',
        invalidToken: 'Neveljavni žeton',
        passwordUpdated: 'Geslo posodobljeno',
        passwordUpdatedDescription:
          'Vaše geslo je bilo uspešno posodobljeno. Hvala, ker ste storili ta korak za varovanje vaših podatkov!',
        passwordUsedBefore: 'Ponovna uporaba gesla ni dovoljena',
        passwordUsedBeforeDescription:
          'Za vašo varnost ne morete ponovno uporabiti nobenega od svojih zadnjih šestih gesel. Izberite novo, edinstveno geslo za varovanje vašega računa in poskusite znova.',
        toastDescription:
          'Vaše geslo je bilo uspešno posodobljeno. Hvala, ker ste sprejeli ta korak za varovanje vaših podatkov!',
        toastMessage: 'Geslo posodobljeno',
        updatePasswordCTA: 'Posodobi geslo',
      },
      ReportingConnect: {
        cancelButton: 'Prekliči',
        connectButton: 'Poveži',
        disclaimer:
          'Povezovanje vašega računa Slack z vašim računom Vault zagotavlja varno in zasebno povezavo.<br /><br />Z povezovanjem lahko poročate o nepravilnostih ali postavite vprašanje neposredno znotraj Slacka. Vedno imate možnost, da po povezavi poročate anonimno. Vaša zasebnost in varnost sta naša najpomembnejša prioriteta.',
        heading:
          'Vault Platform prosi za dovoljenje za dostop do vašega Slack računa {{organisationName}}.',
        listHeading: 'Kaj bo Vault sposoben storiti?',
        permissionIdentity: {
          extraInfo:
            'Vault bo imel možnost ogleda identitete vašega uporabnika Slack.',
          heading: 'Ogled informacij o identiteti uporabnika',
        },
        permissionNotifications: {
          extraInfo:
            'Vault vam bo lahko poslal obvestila na vaš Slack račun, glede kakršnih koli posodobitev poslanega poročila ali vprašanja.',
          heading: 'Pošlji vam obvestila',
        },
        permissionOverview: {
          extraInfo: 'Vault bo na domači strani prikazal pregled vseh oddaj.',
          heading: 'Pregled vložkov',
        },
        permissionSubmitReport: {
          extraInfo:
            'To bo podelilo Vaultu dovoljenje za oddajo poročila ali postavljanje vprašanja, neposredno vaši organizaciji, iz Slacka.',
          heading: 'Predložite poročilo ali vprašanje v vašem imenu',
        },
        successfulConnectionDescription:
          'Vaš račun Vault in račun Slack sta zdaj povezana. Zdaj lahko to zavihek zaprete in se vrnete v Slack.',
        successfulConnectionHeading: 'Uspešno povezano',
        unsuccessfulConnectionDescription:
          'Nekaj je šlo narobe. Prosimo, zaprite ta zavihek in se vrnite v Slack, da poskusite znova.',
        unsuccessfulConnectionHeading: 'Povezava ni uspela',
      },
      ReportingForgotPassword: {
        description:
          'Vnesite e-poštni naslov, povezan z vašim računom, in poslali vam bomo povezavo za ponastavitev gesla.',
        heading: 'Pozabljeno geslo',
        invalidTokenError: 'Ne morem ustvariti gesla, neveljaven žeton.',
        passwordReuseError: 'Ponovna uporaba gesla ni dovoljena',
        passwordReuseErrorDescription:
          'Za vašo varnost ne morete ponovno uporabiti nobenega od svojih zadnjih šestih gesel. Izberite novo, edinstveno geslo, da bo vaš račun varen in poskusite znova.',
        sendLink: 'Pošlji povezavo za ponastavitev',
        sendLinkFailure: 'Nekaj je šlo narobe',
        sendLinkFailureDescription:
          'Vrnite se v <a>Reporter Hub</a> in poskusite znova. Če te težave še vedno obstajajo, se obrnite na nas na naslovu <mailto>techsupport@vaultplatform.com</mailto>',
        sendLinkSuccess: 'Povezava za ponastavitev gesla poslana',
        sendLinkSuccessDescription:
          'Poslali smo povezavo za ponastavitev gesla na {{email}}',
        updatePasswordSuccess: 'Geslo posodobljeno',
        updatePasswordSuccessDescription:
          'Vaše geslo je bilo uspešno posodobljeno. Hvala, ker ste naredili ta korak za ohranjanje vaših podatkov varnih!',
      },
      ReportingLogin: {
        accountFrozen: 'Račun je zamrznjen',
        accountLocked:
          'Poskus prijave je bil izveden prevečkrat neuspešno. Račun je zaklenjen za do 1 uro. Ponastavitev gesla med tem časom ni možna.',
        accountLockedPermanently:
          'Vaš račun je zaklenjen. Uporabite ponastavitev gesla za ponovno pridobitev dostopa ali pa se za nadaljnjo pomoč obrnite na sistemski skrbnik.',
        createAccountCTA: 'Registrirajte se za račun',
        currentPassword: 'Trenutno geslo',
        emailLabel: 'Vaša elektronska pošta',
        forgotPassword: 'Ste pozabili geslo?',
        loginButton: 'Prijava',
        newPasswordPlaceholder: 'Novo geslo',
        passwordFailMessage:
          'Vrnite se v Aplikacijo Vault v Slack in poskusite znova. Če se težava nadaljuje, nas kontaktirajte na techsupport@vaultplatform.com.',
        passwordFailTitle: 'Nekaj je šlo narobe',
        passwordLabel: 'Vaše geslo',
        passwordPlaceholder: 'Vnesite svoje geslo',
        passwordResetRequired: 'Potrebna je ponastavitev gesla',
        passwordSuccessfullySetMessage:
          'Vrnite se v aplikacijo Vault v Slack in se overite z novim geslom, da nadaljujete tam, kjer ste končali.',
        passwordSuccessfullySetTitle: 'Geslo uspešno nastavljeno',
        reenterPlaceholder: 'Ponovno vnesite geslo',
        title: 'Reporter Hub',
        tooltip:
          'Če še niste nastavili gesla za aplikacijo Vault, sledite tukaj, da začnete. Če ste pozabili geslo, uporabite povezavo "Pozabljeno geslo" spodaj.',
        usernameLoginFailed:
          'Prijava ni uspela, uporabniško ime ali geslo je napačno',
      },
      ReportingReset: {
        failureDescription:
          'Vrnite se v aplikacijo Vault v Slacku in poskusite znova. Če se težava nadaljuje, nas kontaktirajte na <mailto>techsupport@vaultplatform.com</mailto>',
        failureHeading: 'Nekaj je šlo narobe',
        successDescription:
          'Vrnite se nazaj v aplikacijo Vault v Slacku in se avtenticirajte z novim geslom, da nadaljujete tam, kjer ste končali.',
        successHeading: 'Geslo uspešno nastavljeno',
      },
      noReports: {
        description:
          'Vsi oddani poročili bodo prikazani tukaj. Več o načinih, kako lahko oddate poročilo, lahko izveste',
        descriptionHelpArticle: 'ta pomočni članek',
        errorDescription:
          'Imamo težave s prenosom vaših poročil. Prosimo, poskusite osvežiti stran.',
        errorDescriptionSecondary:
          'Če to ne deluje, se prosim obrnite na nas na',
        errorTitle: '⚠️ Ups, nekaj je šlo narobe',
        title: 'Nimate še nobenega poročila.',
      },
      settings: {
        messageSettings: {
          autoTranslationDescription1:
            'Omogočite samodejne prevode in preberite vsa poročila v vašem želenem jeziku. Prevedeni jezik temelji na jeziku, ki ste ga izbrali na vaši napravi.',
          autoTranslationDescription2:
            'Med klepeti lahko preklapljate med prevedenim in izvirnim jezikom.',
          autoTranslationTitle:
            'Omogoči samodejno prevajanje poročil o sporočilih',
          header: 'Nastavitve sporočil',
          subHeader: 'Nastavite, kako se prikažejo sporočila',
        },
        notificationSettings: {
          emailDescription:
            'Prejmite e-poštna obvestila za pomembne posodobitve vaših poročil.',
          emailTitle: 'E-poštna obvestila',
          header: 'Nastavitve obvestil',
          subHeader: 'Nastavite, kako prejmete obvestila',
        },
        title: 'Nastavitve',
        updatedSettingsFailure: 'Posodobitev vaših nastavitev ni uspela',
        updatedSettingsSuccess: 'Uspešno ste posodobili svoje nastavitve',
      },
    },
    validators: {
      passwordLength: 'Geslo mora biti dolgo vsaj 9 znakov',
      passwordLowercase: 'Geslo mora vsebovati vsaj 1 malo črko',
      passwordMissMatch: 'Geslo in potrditvena polja se morata ujemati.',
      passwordNumeric: 'Geslo mora vsebovati vsaj 1 številko',
      passwordUppercase: 'Geslo mora vsebovati vsaj 1 veliko črko',
    },
    validatorsNew: {
      passwordLength: 'Med 10 in 30 znaki',
      passwordLowercase: 'Vsaj ena majhna črka',
      passwordMissMatch: 'Gesli se ne ujemata',
      passwordNumeric: 'Vsaj ena številka',
      passwordSpecialCharacter: 'Najmanj en poseben znak',
      passwordUppercase: 'Vsaj ena velika črka',
    },
  },
};

export default translations;
